import { useSelector, useDispatch } from "react-redux";
import { loginAsSuscriptor, logoutAsSuscriptor } from "redux/actions/aLogin";
import { dataUsuarioVacio } from "../constants";
import useCustomToast from "hooks/useCustomToasts";
import { useHistory } from 'react-router-dom';

const useValidationsSuscriptor = () => {
  const { dataUsuario } = useSelector((state) => state.datosUsuarios);
  const dispatch = useDispatch();
  const { addWarningToast } = useCustomToast();
  const history = useHistory();

  const validarSuscriptor = (producto) => {
    if (producto === 'pymesAbiertoInd' && dataUsuario?.isSuscriptor) {
      history.replace('/listado-polizas');
      if (dataUsuario.sesionSuscriptor) {
        dispatch(loginAsSuscriptor(dataUsuario.sesionSuscriptor));
      } else if (dataUsuario.usu_tipo_usuario !== "usu-suscriptor-sbs") {
        dispatch(logoutAsSuscriptor(dataUsuarioVacio));
      }      
      history.push("/");
      addWarningToast("Solo el agente puede continuar con la emisión", {
        autoDismiss: false,
      });      
    }
  };  
  return {
    validarSuscriptor,
  };
};

export default useValidationsSuscriptor;
